import React, { useEffect, useState } from "react";
import { MdOutlineFileUpload, MdOutlineSort } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import Layout from "../components/layout/Layout";
import {
  Button,
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Alert,
  Divider,
  Chip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { dashboards, appsName } from "../dashboardRow";
import company from "../company.json";
import { useRecoilState } from "recoil";
import { catag } from "../state/catagory";
import axios from "axios";
import config from "../config.js";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from "@mui/material";

import {
  setSelectedCompanyId,
  setSelectedCompanyDetails,
  setKycData,
} from "../features/counter/kycSlice";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

const Dashboard = () => {
  const [companyIndex] = useState(0);
   const theme = useTheme();
  const [countryIndex] = useState(0);
  const [cityIndex] = useState(0);
  const [officeIndex] = useState(0);
  const [companyShow, setCompanyShow] = useState(false);
  const [error, setError] = useState(null);

  const [, setData] = useRecoilState(catag);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { API_BASE_URL } = config;
  const selectedCompanyInfo = useSelector(
    (state) => state.kyc.selectedCompanyInfo
  );

  const userId = useSelector((state) => state.auth.user?.id);
  const { kycData } = useSelector((state) => state.kyc);
  const welcomeMessage = selectedCompanyInfo?.legalName
    ? ` ${selectedCompanyInfo?.legalName}`
    : "";

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 },
    },
  };

  const slideVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.2 },
    },
    hover: {
      scale: 1.02,
      transition: { duration: 0.2 },
    },
  };

  useEffect(() => {
    const fetchKycData = async () => {
      if (!userId) return;

      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/getKycData/${userId}`
        );

        const kycDataArray = Array.isArray(response.data.kycData)
          ? response.data.kycData
          : [];

        dispatch(setKycData(kycDataArray));
      } catch (err) {
        setError(err.message);
      }
    };

    fetchKycData();
  }, [dispatch, userId, API_BASE_URL]);

  const handleCompanySelect = (company) => {
    dispatch(setSelectedCompanyId(company._id));
    dispatch(
      setSelectedCompanyDetails({
        companyInfo: company.companyInfo,
        address: company.address,
        contactInfo: company.contactInfo,
        businessInfo: company.businessInfo,
        taxInfo: company.taxInfo,
        complianceInfo: company.complianceInfo,
        bankingInfo: company.bankingInfo,
      })
    );
  };

  const handleViewKycDetails = () => {
    navigate("/KycDetails");
  };

  useEffect(() => {
    if (
      companyIndex === undefined ||
      countryIndex === undefined ||
      cityIndex === undefined ||
      officeIndex === undefined
    )
      return;
    if (!company) return;

    const currentCompany = company.companies?.[companyIndex];
    const currentCountry = currentCompany?.countries?.[countryIndex];
    const currentCity = currentCountry?.cities?.[cityIndex];
    const currentOffice = currentCity?.offices?.[officeIndex];

    if (currentCompany && currentCountry && currentCity && currentOffice) {
      setData((prevData) => ({
        ...prevData,
        companyName: currentCompany.name,
        country: currentCountry.name,
        city: currentCity.name,
        location: currentOffice.name,
      }));
    }
  }, [countryIndex, cityIndex, officeIndex, companyIndex, setData]);

  const handleMouseEnter = () => setCompanyShow(true);
  const handleMouseLeave = () => setCompanyShow(false);

  const kycDataArray = Array.isArray(kycData) ? kycData : [];

  return (
    <Layout>
      <motion.div
        style={{ overflowX: "hidden" }}
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <div className="container-fluid p-0 g-0 m-0">
          <Box sx={{ py: 4 }}>
            <Container
              maxWidth="xl"
              sx={{
                backgroundColor: "primary.main",
                height: { xs: "auto", md: "60px" },
                borderRadius: 2,
                padding: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "visible",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "row",
                  gap: 2,
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    flex: { xs: "1 1 100%", sm: "1 1 30%", md: "0 0 250px" },
                    minWidth: { xs: "100%", sm: "200px" },
                    order: { xs: 1, sm: 1 },
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <motion.div
                      whileHover={{ scale: 1.01 }}
                      whileTap={{ scale: 0.99 }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setCompanyShow(!companyShow)}
                        onMouseEnter={handleMouseEnter}
                        fullWidth
                        endIcon={
                          <motion.div
                            animate={{ rotate: companyShow ? 180 : 0 }}
                            transition={{ duration: 0.3 }}
                          >
                            <KeyboardArrowDownIcon sx={{ color: "inherit" }} />
                          </motion.div>
                        }
                        sx={{
                          height: "42px",
                          display: "flex",
                          justifyContent: "space-between",
                          px: 2,
                          borderRadius: 2,
                          fontSize: "0.9rem",
                          fontWeight: 600,
                          borderColor: "#EB5A3C",
                          backgroundColor: "#F8EEDB",
                          color: "#EB5A3C",
                          "&:hover": {
                            backgroundColor: "#EB5A3C",
                            color: "#fff",
                            "& svg": { color: "#fff" },
                          },
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <MdOutlineSort fontSize={20} />
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Company
                          </Typography>
                        </Box>
                      </Button>
                    </motion.div>

                    {/* Dropdown */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "calc(100% + 6px)",
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        width: "100%",
                      }}
                    >
                      <AnimatePresence>
                        {companyShow && (
                          <motion.div
                            initial={{ opacity: 0, y: -10, scale: 0.95 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: -10, scale: 0.95 }}
                            transition={{ duration: 0.2 }}
                            onMouseLeave={handleMouseLeave}
                          >
                            <Card
                              elevation={2}
                              sx={{
                                borderRadius: 2,
                                backdropFilter: "blur(6px)",
                                backgroundColor: "rgba(255,255,255,0.95)",
                                border: "1px solid #EB5A3C33",
                                boxShadow: 3,
                                overflow: "hidden",
                              }}
                            >
                              <CardContent sx={{ p: 0 }}>
                                <Divider sx={{ my: 1 }}>
                                  <Chip
                                    label="Your Companies"
                                    variant="outlined"
                                    size="small"
                                  />
                                </Divider>

                                {/* Company List */}
                                <Box
                                  sx={{
                                    maxHeight: "240px",
                                    overflowY: "auto",
                                    px: 1,
                                    py: 1,
                                    "&::-webkit-scrollbar": {
                                      width: "6px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#ccc",
                                      borderRadius: 4,
                                    },
                                  }}
                                >
                                  {kycDataArray.length > 0 ? (
                                    kycDataArray.map((company, index) => (
                                      <motion.div
                                        key={company._id || `company-${index}`}
                                        initial={{ opacity: 0, x: -10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: index * 0.05 }}
                                      >
                                        <Button
                                          fullWidth
                                          variant="text"
                                          onClick={() => {
                                            handleCompanySelect(company);
                                            setCompanyShow(false);
                                          }}
                                          sx={{
                                            justifyContent: "flex-start",
                                            px: 2,
                                            py: 1.25,
                                            fontSize: "0.85rem",
                                            borderRadius: 1,
                                            color: "text.primary",
                                            "&:hover": {
                                              background:
                                                "linear-gradient(to right, #FAF3E0, #FCEBD8)",
                                            },
                                          }}
                                        >
                                          {company.companyInfo?.legalName ||
                                            "Unnamed Company"}
                                        </Button>
                                      </motion.div>
                                    ))
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        p: 2,
                                        textAlign: "center",
                                        color: "text.secondary",
                                      }}
                                    >
                                      No companies found
                                    </Typography>
                                  )}
                                </Box>

                                <Divider />

                                <Box sx={{ p: 2 }}>
                                  <motion.div
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                  >
                                    <Button
                                      component={Link}
                                      to="/kycForm"
                                      variant="contained"
                                      fullWidth
                                      startIcon={<AddIcon />}
                                      onClick={() => setCompanyShow(false)}
                                      sx={{
                                        backgroundColor: "#EB5A3C",
                                        "&:hover": {
                                          backgroundColor: "#C94732",
                                        },
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: "0.85rem",
                                        py: 1.25,
                                      }}
                                    >
                                      Add New Company
                                    </Button>
                                  </motion.div>
                                </Box>
                              </CardContent>
                            </Card>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    color: "white",
                    flex: { xs: "1 1 100%", sm: "1 1 auto", md: 1 },
                    display: "flex",
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "center",
                    },
                    alignItems: "center",
                    order: { xs: 2, sm: 2 },
                    minWidth: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        color: "white",
                        fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                      }}
                    >
                      Welcome
                    </Typography>

                    <Button
                      sx={{
                        color: "white",
                        textTransform: "none",
                        fontSize: "inherit",
                        minWidth: "auto",
                        p: 0,
                      }}
                      onClick={handleViewKycDetails}
                    >
                      {welcomeMessage}
                    </Button>
                  </Box>
                </Box>

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", sm: "0 0 auto" },
                    display: "flex",
                    justifyContent: { xs: "center", sm: "flex-end" },
                    alignItems: "center",
                    order: { xs: 3, sm: 3 },
                    minWidth: { xs: "100%", sm: "auto" },
                  }}
                >
                  <Button
                    onClick={() => navigate("/upload")}
                    variant="contained"
                    startIcon={<MdOutlineFileUpload size={20} />}
                    sx={{
                      backgroundColor: theme.palette.secondary.main,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.light,
                      },
                      color: "black",
                      fontWeight: "bold",
                      py: { xs: 1, sm: 1.2 },
                      px: { xs: 2, sm: 2.5 },
                      borderRadius: 1,
                      border: "1px solid white",
                      textTransform: "none",
                      fontSize: { xs: "0.85rem", sm: "0.9rem" },
                      height: { xs: "36px", sm: "40px" },
                      minWidth: { xs: "120px", sm: "140px" },
                    }}
                  >
                    Upload
                  </Button>
                </Box>
              </Box>
            </Container>
          </Box>

          {dashboards?.map((d, index) => (
            <React.Fragment key={index}>
              <motion.div
                className="row firstHeading1 mt-1 p-2"
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 }}
              >
                <div className="dropdown-center">
                  <motion.button
                    className="btn dropdown-toggle btn-sm btn-outline-danger btn-outline-red border-0"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {d.name}
                  </motion.button>
                  <motion.ul
                    className="dropdown-menu"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    {d.reports.map((r, i) => {
                      return (
                        <motion.div
                          key={r.id}
                          whileHover={{
                            backgroundColor: "rgba(255, 76, 76, 0.1)",
                          }}
                        >
                          <Link
                            style={{
                              padding: 0,
                              margin: 0,
                              textDecoration: "none",
                            }}
                            to={`/${r.href}`}
                            className="dropdown-item"
                          >
                            {r.name}
                          </Link>
                        </motion.div>
                      );
                    })}
                  </motion.ul>
                </div>
              </motion.div>

              <motion.div
                className="row p-2"
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 + 0.1 }}
              >
                <div className="parentService" style={{ height: "212px" }}>
                  <Swiper
                    className="mySwiper"
                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                    spaceBetween={20}
                    slidesPerView={4}
                    loop={true}
                    navigation
                    pagination={{ clickable: true, el: ".swiper-pagination" }}
                    centeredSlides={false}
                  >
                    {d?.reports.map((r, i) => (
                      <SwiperSlide
                        key={i}
                        onClick={() => {
                          if (d?.id === 6 && i === 0) {
                            navigate("/MarketingDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 5 && i === 0) {
                            navigate("/salesDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 2 && i === 0) {
                            navigate("/FinnanceDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 4 && i === 0) {
                            navigate("/EmployeeDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 7 && i === 0) {
                            navigate("/salesDashboard2", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 3 && i === 5) {
                            navigate("/inventory", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 4 && i === 8) {
                            navigate("/healthandwellness", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 7 && i === 6) {
                            navigate("/logistic", { state: { name: r?.name } });
                          } else if (d?.id === 4 && i === 3) {
                            navigate("/logistic", { state: { name: r?.name } });
                          } else if (d?.id === 1 && i === 1) {
                            navigate("/CashFlowDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 1 && i === 4) {
                            navigate("/InvestmentScheduleDashboard", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 1 && i === 3) {
                            navigate("/PartnersCapital", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 1 && i === 2) {
                            navigate("/Profir_Loss", {
                              state: { name: r?.name },
                            });
                          } else if (d?.id === 1 && i === 0) {
                            navigate("/BalanceSheet", {
                              state: { name: r?.name },
                            });
                          } else {
                            navigate(`/dashboard/${d?.id}/sales/${i}`);
                          }
                        }}
                        style={{ width: "25%" }}
                      >
                        <motion.div
                          className={`innerCard ${
                            i > 0 ? "innerCardSize" : ""
                          }`}
                          variants={slideVariants}
                          initial="hidden"
                          animate="visible"
                          whileHover="hover"
                          transition={{ delay: i * 0.05 }}
                        >
                          <img
                            src="https://assets.startbootstrap.com/img/screenshots-product-pages/sb-admin-pro/pages/account-billing.png"
                            alt="1"
                          />
                          <p>{r.name}</p>
                        </motion.div>
                      </SwiperSlide>
                    ))}
                    <div className="swiper-pagination"></div>
                  </Swiper>
                </div>
              </motion.div>
            </React.Fragment>
          ))}

          <motion.div
            className="row firstHeading mt-1 p-2"
            variants={itemVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.5 }}
          >
            <h3>App Pages</h3>
            <hr />

            {appsName?.map((a, i) => (
              <React.Fragment key={i}>
                <motion.div
                  className="row firstHeading mt-1 p-2"
                  variants={itemVariants}
                  transition={{ delay: i * 0.05 }}
                >
                  <h6>{a.category}</h6>
                </motion.div>
                <motion.div
                  className="row p-2"
                  variants={itemVariants}
                  transition={{ delay: i * 0.05 + 0.1 }}
                >
                  {a?.apps?.map((r, appIndex) => (
                    <div key={appIndex} className="col-md-3">
                      <motion.div
                        variants={slideVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                        transition={{ delay: appIndex * 0.02 }}
                      >
                        <Link
                          to={{
                            pathname: "/accountprofile",
                            search: `?page=${r?.slug}`,
                          }}
                          className="appsCard"
                        >
                          <img
                            src="https://assets.startbootstrap.com/img/screenshots-product-pages/sb-admin-pro/pages/auth-login-social.png"
                            alt="apps"
                          />
                          <p>{r?.name}</p>
                        </Link>
                      </motion.div>
                    </div>
                  ))}
                </motion.div>
              </React.Fragment>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </Layout>
  );
};

export default Dashboard;
